import React from 'react';
import { Link } from 'react-router-dom';

import logo from '../../assets/images/kbglogo.png';
import paintbrushFooter from '../../assets/images/paintbrush_footer.png';
import wigglyLine from '../../assets/images/LPWigglyLine.svg';
import { EmailIcon, FileIcon, LinkedinIcon } from '../icons/icons';

import style from './footer.module.scss';

export default function Footer() {
  return (
    <div className={style.stack}>
      <div className={style.paintbrushBand} aria-hidden>
        <img src={paintbrushFooter} alt="" className={style.paintbrushImg} />
      </div>
      <footer className={style.root}>

      <div className={style.bar}>
        <Link to="/" className={style.logoLink}>
          <img src={logo} alt="KBG Design home" className={style.logo} />
        </Link>

        <ul className={style.iconList}>
          <li>
            <a
              href="mailto:kbermangestring@gmail.com"
              className={style.iconLink}
              aria-label="Email Kyra at kbermangestring@gmail.com"
            >
              <EmailIcon className={style.icon} aria-hidden />
            </a>
          </li>
          <li>
            <Link to="/resume" className={style.iconLink} aria-label="View résumé">
              <FileIcon className={style.icon} aria-hidden />
            </Link>
          </li>
          <li>
            <a
              href="https://www.linkedin.com/in/kyrabermangestring/"
              className={style.iconLink}
              target="_blank"
              rel="noreferrer"
              aria-label="Kyra on LinkedIn (opens in new tab)"
            >
              <LinkedinIcon className={style.icon} aria-hidden />
            </a>
          </li>
        </ul>
      </div>
    </footer>
    </div>
  );
}
